module.exports = __webpack_public_path__ + "static/media/logo-green.2263b15b.svg";